import { Model } from "@mcleod/core";
import { ImageRetrieverInterface, ImageViewer, ImageViewerValues } from "@mcleod/components";

export class ImageRetriever implements ImageRetrieverInterface {
    public async get(id: string, fileName: string): Promise<ImageViewerValues> {
        return await this.getFromServer("common/imaging/get-image", id, fileName);
    }

    public async getAsPdf(id: string, fileName: string): Promise<ImageViewerValues> {
        return await this.getFromServer("common/imaging/get-image-pdf", id, fileName);
    }

    private async getFromServer(endpoint: string, id: string, fileName: string): Promise<ImageViewerValues> {
        const row = await Model.searchSingleRecord(endpoint, { id: id });
        if (row == null) {
            return null;
        }
        const imageBase64 = row.get("image");
        const finalizedFileName = fileName + row.get("file_ext", ".image");
        return new ImageViewerValues(id, imageBase64, finalizedFileName);
    }
}
// Inject into ImageViewer, which resides in the components package
ImageViewer.imageRetriever = new ImageRetriever();
